import $ from 'jquery';
import { db } from './database';
export { getMealId, getRecipe, getRecipeById };
async function getMealId(el) {
    const target = $(el).hasClass('recipe') ? $(el) : $(el).parents('.recipe');
    return await target.data('meal-id');
}
async function getRecipeById(recipeId) {
    return await db.recipes.get(recipeId, async (recipe) => {
        if (recipe)
            return recipe;
        return await $.ajax({ url: `/api/recipes/${recipeId}/view` }).then(hits => {
            if (hits.total === 1)
                return hits.results[0];
        });
    });
}
async function getRecipe(el) {
    let recipe;
    const target = $(el).hasClass('recipe') ? $(el) : $(el).parents('.recipe');
    const recipeList = $(target).parents('table[data-row-attributes]');
    if (recipeList.length) {
        const index = target.data('index');
        recipe = $(recipeList).bootstrapTable('getData')[index];
    }
    else {
        const recipeId = target.data('id');
        recipe = await getRecipeById(recipeId);
    }
    return recipe;
}
